import React from 'react';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Lor95 UI error:', error, info);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="min-h-screen bg-[#f8f5f0] flex items-center justify-center px-4">
        <div className="max-w-xl w-full bg-white border border-[#e8dece] shadow-lg p-7 sm:p-10 text-center">
          <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto">
            <AlertTriangle className="h-7 w-7 text-amber-700" />
          </div>

          <p className="text-[#b78332] text-xs font-bold tracking-[0.25em] uppercase mt-5">
            LOR95 BOUTIQUE
          </p>

          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 mt-2">
            Diçka nuk shkoi siç duhet
          </h1>

          <p className="text-gray-500 mt-4 leading-relaxed">
            Faqja hasi një problem të përkohshëm. Rifreskojeni faqen ose kthehuni te kryefaqja.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-7">
            <button
              type="button"
              onClick={this.handleReload}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 font-semibold transition-colors"
            >
              <RefreshCw className="h-4 w-4" />
              Rifresko Faqen
            </button>

            <button
              type="button"
              onClick={this.handleHome}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-gray-900 text-gray-900 hover:bg-gray-50 px-6 py-3 font-semibold transition-colors"
            >
              <Home className="h-4 w-4" />
              Kryefaqja
            </button>
          </div>
        </div>
      </div>
    );
  }
}
